import { useEffect, useState } from 'react';
import { appBreakpoints } from '../reducers';

type Breakpoint = keyof typeof appBreakpoints;
type Comparison = 'greaterThan' | 'lessThanOrEqual';

const queryFor = (breakpoint: Breakpoint, comparison: Comparison): string => {
  const px = appBreakpoints[breakpoint];
  return comparison === 'greaterThan'
    ? `(min-width: ${px + 1}px)`
    : `(max-width: ${px}px)`;
};

// Replaces redux-responsive's `state.browser.{greaterThan,lessThan}` selectors.
const useBreakpoint = (
  breakpoint: Breakpoint,
  comparison: Comparison,
): boolean => {
  const query = queryFor(breakpoint, comparison);
  const [matches, setMatches] = useState(() =>
    globalThis.matchMedia === undefined
      ? false
      : globalThis.matchMedia(query).matches,
  );

  useEffect(() => {
    if (globalThis.matchMedia === undefined) return undefined;
    const mediaQueryList = globalThis.matchMedia(query);
    const handleChange = () => setMatches(mediaQueryList.matches);
    handleChange();
    mediaQueryList.addEventListener('change', handleChange);
    return () => mediaQueryList.removeEventListener('change', handleChange);
  }, [query]);

  return matches;
};

export default useBreakpoint;
